import { CSSProperties, FC } from 'react'
import styles from './OrganizerHeader.module.scss'
import { useTranslation } from 'next-i18next'
import { Organizer } from '~/modules/Organizers/Domain/Organizer'

interface Props {
  organizer: Organizer
  trophyAmount: number
}

export const OrganizerHeader: FC<Props> = ({ organizer, trophyAmount }) => {
  const { t } = useTranslation('organizer_header')

  return (
    <header
      className={ styles.organizerHeader__background }
      style={ {
        backgroundImage: `url(${organizer.bannerUrl})`,
        '--neon-color': organizer.brandHexColor,
      } as CSSProperties }
    >
      <div className={ styles.organizerHeader__container }>
        <div className={ styles.organizerHeader__layout }>
          <object
            data={ organizer.avatarUrl ?? undefined }
            className={ styles.organizerHeader__avatarWrapper }
          >
            <img
              src={ '/img/defaults/organizer.png' }
              className={ styles.organizerHeader__avatar }
              alt={ t('header_avatar_image') }
            />
          </object>

          <h1 className={ styles.organizerHeader__title }>
            <small className={ styles.organizerHeader__titleLabel }>
              { t('organizer_title') }
            </small>
            { organizer.name }
          </h1>

          <div className={ styles.organizerHeader__trophyCount }>
            { t('trophies') }
            <strong className={ styles.organizerHeader__trophyCountValue }>
              { trophyAmount }
            </strong>
          </div>

          <div className={ styles.organizerHeader__place }>
            { t('location') }
            <strong className={ styles.organizerHeader__placeValue }>
              { organizer.place }
            </strong>
          </div>
        </div>
      </div>
    </header>
  )
}
